import axios from 'axios';
const PRODUCTS =  axios.create({
    baseURL: 'https://panel.construproductos.com/api/v1/',
   //baseURL: 'https://panel1.construproductos.com/api/v1/',
   //baseURL: 'http://localhost:8000/api/v1/',
    //baseURL: 'http://localhost:8000/',
    //baseURL:'http://arquiadmin.expodeco.info/api/v1',
    // baseURL:'http://arquiadmin.expodeco.info/public/api/v1',
    timeout: 20000,
    headers: {
        'Content-Type': 'application/json',
        'catalog-client': 'arqui'
    }
});

export default {
    PRODUCTS
}